/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Already_Disabled_For_SessionInputs */

const en_disabled_websites_already_disabled_for_session = /** @type {(inputs: Disabled_Websites_Already_Disabled_For_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already Disabled for Session`)
};

const es_disabled_websites_already_disabled_for_session = /** @type {(inputs: Disabled_Websites_Already_Disabled_For_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya deshabilitado en esta sesión`)
};

/**
* | output |
* | --- |
* | "Already Disabled for Session" |
*
* @param {Disabled_Websites_Already_Disabled_For_SessionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_already_disabled_for_session = /** @type {((inputs?: Disabled_Websites_Already_Disabled_For_SessionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Already_Disabled_For_SessionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_already_disabled_for_session(inputs)
	return en_disabled_websites_already_disabled_for_session(inputs)
});